import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7da6fc6b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "user-infos",
  class: "description-list"
}
const _hoisted_2 = { class: "user-bio" }
const _hoisted_3 = {
  key: 1,
  class: "profile-buttons"
}
const _hoisted_4 = {
  key: 2,
  class: "profile-buttons"
}

import { format } from 'date-fns'
  import { ComputedRef, Ref, computed, ref, toRefs, withDefaults } from 'vue'

  import { AUTH_USER_STORE, USERS_STORE } from '@/store/constants'
  import { IUserProfile } from '@/types/user'
  import { useStore } from '@/use/useStore'

  interface Props {
    user: IUserProfile
    fromAdmin?: boolean
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    user: null,
    fromAdmin: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { user: IUserProfile, fromAdmin: boolean }

  

  const store = useStore()

  const { user, fromAdmin } = toRefs(props)
  const authUser: ComputedRef<IUserProfile> = computed(
    () => store.getters[AUTH_USER_STORE.GETTERS.AUTH_USER_PROFILE]
  )
  const registrationDate = computed(() =>
    props.user.created_at
      ? format(new Date(props.user.created_at), 'dd/MM/yyyy HH:mm')
      : ''
  )
  const birthDate = computed(() =>
    props.user.birth_date
      ? format(new Date(props.user.birth_date), 'dd/MM/yyyy')
      : ''
  )
  let displayModal: Ref<boolean> = ref(false)

  function updateDisplayModal(value: boolean) {
    displayModal.value = value
  }
  function deleteUserAccount(username: string) {
    store.dispatch(USERS_STORE.ACTIONS.DELETE_USER_ACCOUNT, { username })
  }

return (_ctx: any,_cache: any) => {
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(displayModal))
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 0,
          title: _ctx.$t('common.CONFIRMATION'),
          message: "admin.CONFIRM_USER_ACCOUNT_DELETION",
          strongMessage: _unref(user).username,
          onConfirmAction: _cache[0] || (_cache[0] = ($event: any) => (deleteUserAccount(_unref(user).username))),
          onCancelAction: _cache[1] || (_cache[1] = ($event: any) => (updateDisplayModal(false)))
        }, null, 8, ["title", "strongMessage"]))
      : _createCommentVNode("", true),
    _createElementVNode("dl", null, [
      _createElementVNode("dt", null, _toDisplayString(_ctx.$t('user.PROFILE.REGISTRATION_DATE')) + ":", 1),
      _createElementVNode("dd", null, _toDisplayString(_unref(registrationDate)), 1),
      _createElementVNode("dt", null, _toDisplayString(_ctx.$t('user.PROFILE.FIRST_NAME')) + ":", 1),
      _createElementVNode("dd", null, _toDisplayString(_unref(user).first_name), 1),
      _createElementVNode("dt", null, _toDisplayString(_ctx.$t('user.PROFILE.LAST_NAME')) + ":", 1),
      _createElementVNode("dd", null, _toDisplayString(_unref(user).last_name), 1),
      _createElementVNode("dt", null, _toDisplayString(_ctx.$t('user.PROFILE.BIRTH_DATE')) + ":", 1),
      _createElementVNode("dd", null, _toDisplayString(_unref(birthDate)), 1),
      _createElementVNode("dt", null, _toDisplayString(_ctx.$t('user.PROFILE.LOCATION')) + ":", 1),
      _createElementVNode("dd", null, _toDisplayString(_unref(user).location), 1),
      _createElementVNode("dt", null, _toDisplayString(_ctx.$t('user.PROFILE.BIO')) + ":", 1),
      _createElementVNode("dd", _hoisted_2, _toDisplayString(_unref(user).bio), 1)
    ]),
    (_unref(fromAdmin))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_unref(authUser).username !== _unref(user).username)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "danger",
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (updateDisplayModal(true)), ["prevent"]))
              }, _toDisplayString(_ctx.$t('admin.DELETE_USER')), 1))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.go(-1)))
          }, _toDisplayString(_ctx.$t('buttons.BACK')), 1)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("button", {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push('/profile/edit')))
          }, _toDisplayString(_ctx.$t('user.PROFILE.EDIT')), 1),
          _createElementVNode("button", {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.push('/')))
          }, _toDisplayString(_ctx.$t('common.HOME')), 1)
        ]))
  ]))
}
}

})